module.exports = "<app-header></app-header>\n<section class=\"main-content columns is-fullheight is-bg-light\">\n  <aside class=\"sidebar-menu column is-2-mobile is-3 is-fullheight section\">\n    <app-left-sidebar></app-left-sidebar>\n  </aside>\n  <div class=\"body-content column is-10-mobile is-10 is-bg-white section\">\n      <router-outlet></router-outlet>\n\n  </div>\n</section>\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main